"use client"
import { isOpenInApp } from "@repo/shared-utils/pwa-utils";
import { useEffect, useRef } from "react";

const useModalCloseOnBrowserButton = (
	modalOpen: boolean,
	onClose: () => void,
) => {
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!isOpenInApp() || !modalOpen) return;

    document.body.classList.add("modal-open");
    window.history.pushState({ modalOpen: true }, "");

    const handlePopState = () => {
      onCloseRef.current();
    };
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
      document.body.classList.remove("modal-open");
      if (window.history.state?.modalOpen) {
        window.history.back();
      }
    };
  }, [modalOpen]);
};

export default useModalCloseOnBrowserButton;
